export default __webpack_public_path__ + "static/media/star-icon.c5435c08.svg";